import { useEffect } from "react";

import { Alert } from "@smart/itops-sb-design-system-dom";

import { useBannersVisibility } from "../../hooks";
import { getUITranslation } from "../../utils";

type ConnectionBannerProps = {
  connectionError: boolean;
  retry: (() => void) | undefined;
  selectedLanguage?: string;
};

export const ConnectionBanner = ({
  connectionError,
  retry,
  selectedLanguage,
}: ConnectionBannerProps) => {
  const bannersVisibility = useBannersVisibility();

  useEffect(() => {
    if (connectionError && bannersVisibility) {
      bannersVisibility.open("CONNECTION");
    }
  }, [connectionError]);

  return (
    bannersVisibility &&
    bannersVisibility.visibility.CONNECTION && (
      <Alert
        palette={connectionError ? "destructive" : "success"}
        content={
          connectionError
            ? getUITranslation("connectionSaveFailed", selectedLanguage)
            : getUITranslation("connectionAutoSaveMessage", selectedLanguage)
        }
        actions={
          connectionError && retry
            ? [
                {
                  text: getUITranslation(
                    "connectionTryAgain",
                    selectedLanguage,
                  ),
                  variant: "subtle",
                  onClick: retry,
                },
              ]
            : []
        }
        onClose={() => bannersVisibility.close("CONNECTION")}
      />
    )
  );
};
